import { GridSortItem } from "@mui/x-data-grid";
import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import { OperationFilters } from "Interfaces/OperationFilters";
import { IOperation } from "../../Models/Operation";

export interface IOperationState {
    searchText: string;
    pageIndex: number;
    pageNumber: number;
    pageSize: number;
    total: number;
    sort: GridSortItem[];
    filters: OperationFilters;
    currentOperation:IOperation | null;
}

const initialState: IOperationState = {
    searchText: "",
    pageIndex: 0,
    pageNumber: 0,
    pageSize: 10,
    total: 0,
    sort: [
        {
            field: "operationDate",
            sort: "asc",
        },
    ],
    filters: {},
    currentOperation: null,
};
export const operationSlice = createSlice({
    initialState,
    name: "operationSlice",
    reducers: {
        setSearchText: (state, action: PayloadAction<string>) => {
            state.searchText = action.payload;
        },
        setPageIndex: (state, action: PayloadAction<number>) => {
            state.pageIndex = action.payload;
        },
        setPageSize: (state, action: PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setTotal: (state, action: PayloadAction<number>) => {
            state.total = action.payload;
        },
        setSort: (state, action: PayloadAction<GridSortItem[]>) => {
            state.sort = action.payload;
        },
        updateFilters: (state, action: PayloadAction<OperationFilters>) => {
            state.filters = action.payload;
        },
        removeCurrentFilters: (state, action: PayloadAction<string>) => {
            let filtersWithRemovedCode: OperationFilters = {
                ...current(state).filters,
            };
            delete filtersWithRemovedCode[action.payload as keyof OperationFilters];
            state.filters = filtersWithRemovedCode;
        },
        setCurrentOperation: (state, action: PayloadAction<IOperation | null>) => {
            state.currentOperation = action.payload;
        },
        
        clearCurrentOperation: (state) => {
            state.currentOperation = null;
        },
    },
});
export default operationSlice.reducer;
export const { setSearchText, setPageIndex, setPageSize, setTotal, setSort, updateFilters, removeCurrentFilters,setCurrentOperation,clearCurrentOperation } = operationSlice.actions;